import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'
import moment from 'moment'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

class MarkTypeExpirationSetting extends Component {
  static propTypes = {
    markType: PropTypes.object,
    setting: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      submitting: false,
      error: null,
      markExpirationDate: null,
      success: false
    }
  }

  componentDidMount () {
    this.setState({
      markExpirationDate: moment(this.props.setting.value)
    })
  }

  onExpirationDateChange = value => {
    this.setState({ markExpirationDate: value })
  }

  onSubmit = async (e) => {
    e.preventDefault()
    this.setState({ submitting: true, error: null, success: false })
    const result = await SostaOnlineApiService.updateSetting(
      this.props.setting.name,
      this.state.markExpirationDate.format()
    )

    if (result.result === 'ok') {
      this.setState({ submitting: false, error: false, success: true })
    } else {
      this.setState({ submitting: false, error: true, success: false })
    }
  }

  render () {
    const { markType } = this.props
    return (
      <form onSubmit={this.onSubmit}>
        <div
          style={{
            marginTop: 20,
            marginBottom: 20,
            paddingTop: 20,
            paddingBottom: 20,
            borderBottom: 'rgb(229, 229, 229) solid 1px'
          }}
          className="box"
        >
          <div className="row">
            <div className="col-md-12 text-left">
              <label style={{ marginTop: 5 }} className="col-md-5">
                Data di Scadenza contrassegni <u>{markType.name}</u>
              </label>
              <div className="col-md-2">
                <DatePicker
                  required
                  className="resident-login"
                  selected={this.state.markExpirationDate}
                  onChange={this.onExpirationDateChange}
                />
              </div>
              <div className="col-md-1 text-left">
                <button type="submit" className="btn btn-green">
                  Salva
                </button>
              </div>
              <div className="col-md-4 text-left">
                {this.state.submitting && <div className="text-primary">Salvataggio in corso...</div>}
                {this.state.error && <div onClick={() => this.setState({error: null})} style={{cursor: 'pointer'}} className="text-danger">Si sono verificati degli errori</div>}
                {this.state.success && <div onClick={() => this.setState({success: false})} style={{cursor: 'pointer'}} className="text-success">Salvataggio completato correttamente</div>}
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default MarkTypeExpirationSetting



// WEBPACK FOOTER //
// ./src/containers/Backoffice/Settings/MarkTypeExpirationSetting.js